
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold">GCM MOBILE NOTARY</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Professional mobile notary services in Sherman Oaks and throughout the San Fernando Valley. 
              Fast, reliable, and convenient notarization at your location.
            </p>
            <div className="space-y-2 mb-4">
              <div className="flex items-center space-x-2 text-gray-300">
                <i className="ri-map-pin-line text-orange-400"></i>
                <span>5103 Longridge Ave. Sherman Oaks, CA 91423</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <i className="ri-phone-line text-orange-400"></i>
                <span>(877) 211-3011</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <i className="ri-mail-line text-orange-400"></i>
                <span>office@notaryshermanoaks.com</span>
              </div>
            </div>
            <div className="flex space-x-4">
              <a href="tel:+18772113011" className="text-gray-300 hover:text-orange-400 cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
              <a href="mailto:office@notaryshermanoaks.com" className="text-gray-300 hover:text-orange-400 cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-orange-400 transition-colors">About</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors">Services</Link></li>
              <li><Link to="/service-area" className="text-gray-300 hover:text-orange-400 transition-colors">Service Area</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-orange-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Power of Attorney</li>
              <li>Real Estate Documents</li>
              <li>Living Trusts & Wills</li>
              <li>Apostille Services</li>
              <li>Travel Consent Forms</li>
              <li>Courier Services</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 GCM Mobile Notary. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;